import axios from "axios";

export default axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  //withCredentials: true,
  mode: "cors",
        headers:{'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'},
});
